
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Shell from './components/Shell/Shell';
import LoginPage from './features/login/LoginPage';
import MeetJoinPage from './features/meetings/MeetJoinPage';
import { AppStateContext, defaultAppState } from './context/AppStateContext';
import { ToastContext, useToastProvider } from './context/ToastContext';
import ToastContainer from './components/Toast/ToastContainer';

// Wrapper for dashboard routes that require login
function DashboardRoutes() {
  const [appState, setAppState] = useState(defaultAppState);
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('amp_logged_in') === 'true';
  });

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('amp_logged_in', 'true');
  };

  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <AppStateContext.Provider value={{ appState, setAppState }}>
      <Shell />
    </AppStateContext.Provider>
  );
}

function App() {
  const toastCtx = useToastProvider();

  return (
    <BrowserRouter>
      <ToastContext.Provider value={toastCtx}>
        <Routes>
          {/* Standalone meeting join page - no login required */}
          <Route path="/meet/:roomCode" element={<MeetJoinPage />} />

          {/* Dashboard routes - login required */}
          <Route path="/*" element={<DashboardRoutes />} />
        </Routes>
        <ToastContainer toasts={toastCtx.toasts} removeToast={toastCtx.removeToast} />
      </ToastContext.Provider>
    </BrowserRouter>
  );
}

export default App;
